$(document).ready(function () {
    $('#shopify-section-header').append($('.mega-menu-section.mega-menu-1').html());
    $('.mega-menu-section.mega-menu-1').html('');
    $('#shopify-section-header').append($('.mega-menu-section.mega-menu-2').html());
    $('.mega-menu-section.mega-menu-2').html('');
    $('#shopify-section-header').append($('.mega-menu-section.mega-menu-3').html());
    $('.mega-menu-section.mega-menu-3').html('');

    const megaMenuGridWrapper = $('.js-mega-menu-grid-wrapper');
    const megaMenuGridWrapperMob=$('.js-mega-menu-grid-wrapper-mob');
    if (megaMenuGridWrapper.length > 0) {
        const megaMmenuGridContent = $('.js-mega-menu-grid-content');
        const megaMenuGridNav = $('.mega-menu__grid--has-products-grid .mega-menu__filters');
        const megaMenuGridNavInnerHTML = megaMenuGridNav?.html();
        megaMenuGridNav.html("");
        let isFirst= true;
        megaMmenuGridContent.each(function () {
            if($(this).find(".js-mega-menu-tab-desk").length>0) {
                megaMenuGridWrapper.append($(this).find(".js-mega-menu-tab-desk").html());
                megaMenuGridNav.append(`<button type="button" class="mega-menu__filter-btn js-mega-menu-filter-btn ${isFirst == true ? "is-active" : ""}" data-value="${$(this).attr("data-value")}">${$(this).attr("data-ttl")}</button>`);
                if (isFirst == true) {
                    megaMenuGridWrapper.find(".js-mega-menu-tab-content").removeClass("is-hidden")
                }
                isFirst= false;
            }

            megaMenuGridWrapperMob?.append($(this)?.find(".js-mega-menu-tab-mob")?.html());



            $(this).remove();
        });

        megaMenuGridNav?.html(megaMenuGridNav.html()+megaMenuGridNavInnerHTML);

    }

    $('.js-mega-menu-mobile').each(function () {
        var value = $(this).attr('data-value');
        var toggle = $('.mobile-nav-wrapper .js-mega-menu-navbar-toggle[data-navlink-handle=' + value + ']');
        if (toggle.length > 0) {
            toggle.after($(this));
            toggle.parents('li')?.addClass('is-parent')
        }
    });
    $('body').on('click', '.js-mega-menu-mob-toggle', function (e) {
        e.preventDefault();
        $(this).addClass('is-open')
    });

    function showMegaMenu() {
        $('body').addClass('is-show-mega-menu');
    }

    function hideMegaMenu() {
        if (!$('body').hasClass('is-quick-view-modal-show')) {
            $('.js-mega-menu-mobile-desktop').removeClass('is-active');
            $('body').removeClass('is-show-mega-menu');
            $('.js-mega-menu-navbar-item').removeClass('is-mega-menu-open');
            $('.js-mega-menu-navbar-toggle').removeClass('is-mega-menu-open');
        }
    }


    function showMegaNavBlock(menuLink, navItem) {
        $('.js-mega-menu-navbar-toggle').removeClass('is-mega-menu-open');
        navItem.addClass('is-mega-menu-open');
        $('.mega-menu.clone').removeClass('is-active');
        // $('.mega-menu[data-parent-link=' + menuLink + ']').css("top", getHeaderHeight());
        $('.mega-menu[data-parent-link=' + menuLink + ']').addClass('is-active');
        showMegaMenu();
    }

    function showMegaNavBlockMob(menuLink, navItem) {
        $('.js-mega-menu-navbar-toggle').removeClass('is-mega-menu-open');
        $('.mega-menu-mob__toggle').removeClass('is-open');
        navItem.addClass('is-mega-menu-open');
        $('.mega-menu.clone').removeClass('is-show');
        $('.mega-menu[data-parent-link=' + menuLink + ']').addClass('is-show');
        showMegaMenu();
    }

    function showMegaNavBlockHide() {
        $('.js-mega-menu-navbar-toggle').removeClass('is-mega-menu-open');
        $('.mega-menu.clone').removeClass('is-show');
        $('.mega-menu-mob__toggle').removeClass('is-open');
        hideMegaMenu();
    }


    $('body').on('click', '.mega-menu__mob-back', function (e) {
        e.preventDefault();
        showMegaNavBlockHide();
    });

    $('.js-mega-menu-mobile-desktop, .js-mega-menu-navbar-toggle').on('mouseleave', function () {
        hideMegaMenu();
    })

    $('.js-mega-menu-navbar-toggle').each(function () {
        var navItem = $(this);
        var linkAttr = $(this).attr('data-navlink-handle');
        var menu = $('.mega-menu[data-parent-link=' + linkAttr + ']')

        if(navItem?.parent()?.find(".js-mega-menu-mobile").length>0){return;}
        if (menu.length > 0) {
            $('.js-mega-menu-navbar-toggle', this).attr('href', '#').on('click', function (e) {
                e.preventDefault();
            });
            if ($(this).parents('.mobile-nav-wrapper').length > 0) {
                if (menu.parents('.mega-menu__mega-menu-1').length == 0) {
                    $(this).append('<svg width="10" height="16" viewBox="0 0 10 16" fill="none" xmlns="http://www.w3.org/2000/svg">' +
                        '<path d="M2 2L8 8L2 14" stroke="black" stroke-width="2.42" stroke-linecap="round" stroke-linejoin="round"/>' +
                        '</svg>');

                    $(this).on('click', function (e) {
                        e.preventDefault();
                        var navItem = $(this);
                        showMegaNavBlockMob(linkAttr, navItem);
                    });
                }
            } else {
                $(this).append('<svg class="site-nav__link-svg" width="7" height="5" viewBox="0 0 7 5" fill="none" xmlns="http://www.w3.org/2000/svg">' +
                    '<path d="M6 1.25L3.5 3.75L0.999999 1.25" stroke="currentColor" stroke-width="1.42" stroke-linecap="round" stroke-linejoin="round"/>' +
                    '</svg>');

                $(this).on('click touchstart mouseover', function () {
                    var navItem = $(this);
                    showMegaNavBlock(linkAttr, navItem);
                });
                $(menu).on('mouseover', function () {
                    showMegaNavBlock(linkAttr, navItem);
                });
            }
        }
    });

    $('.js-mega-menu-toggle-mobile').on('click', function (e) {
        e.preventDefault();
        var isOpen = $(this).hasClass('is-open');
        $('.js-mega-menu-toggle-mobile').removeClass('is-open');
        $('.js-mega-menu-toggle-mobile').next().slideUp(300);
        if (!isOpen) {
            $(this).addClass('is-open');
            $(this).next().slideDown(300);
        }
    });

    $('.js-mega-menu-filter-btn').on('click', function (e) {
        e.preventDefault();
        const value = $(this).attr('data-value');
        const parentEl = $(this).parents('.mega-menu__grid');
        const tabs = parentEl.find('.js-mega-menu-tab-content');
        const tabActive = parentEl.find(`.js-mega-menu-tab-content[data-value="${value}"]`);
        $('.js-mega-menu-filter-btn').each(function (){
            $(this).removeClass("is-active")
        });
        tabs.each(function (){
            $(this).addClass("is-hidden")
        });
        tabActive?.removeClass("is-hidden")
        $(this).addClass('is-active');

    });
    $('.js-mega-menu-filter-btn.is-active').click();
    $('.js-mega-menu-filter-toggle').on('click', function (e) {
        e.preventDefault();
        const isOpen = $(this).hasClass('is-active');
        $('.js-mega-menu-filter-toggle').each(function (){
           $(this).removeClass("is-active")
        });
        if(!isOpen){
            $(this).addClass("is-active")
        }
    });

});